  $(document).ready(function() {
    $('.prod-tab-content:not(:first)').hide();
    $('#prod-tab-nav li').click(function() {
      var clickedTab = $(this);
      var clickedContentId = clickedTab.find('a').attr('href');
      $('#prod-tab-nav li').removeClass('active');
      clickedTab.addClass('active');
      $('.prod-tab-content').hide();
      $(clickedContentId).fadeIn();
      return false;
    });
    $('#prod-tab-nav li:first-child').addClass('active');
    $('.prod-tab-content:first').show();
  });

 //  $(document).ready(function() {
 //    $('.menu-link a').click(function(e) {
 //        e.preventDefault(); // Prevent the default link behavior
 //        $('.menu-link').removeClass('active'); // Remove active class from all menu items
 //        $(this).parent().addClass('active'); // Add active class to the clicked menu item
 //    });
 // });


